import { Component, computed, inject } from '@angular/core';
import { RolloutProgressReportGroupsService } from '../../../service/groups/rollout-progress-report-groups.service';
import { RolloutProgressReportsService } from '../../../service/reports/rollout-progress-reports.service';
import { ReportGroupV2Component } from './report-group-v2/report-group-v2.component';

@Component({
  selector: 'app-report-groups-v2',
  imports: [ReportGroupV2Component],
  templateUrl: './report-groups-v2.component.html',
  styleUrl: './report-groups-v2.component.scss',
})
export class ReportGroupsV2Component {
  private readonly reportService = inject(RolloutProgressReportsService);
  private readonly reportGroupsService = inject(
    RolloutProgressReportGroupsService,
  );

  reportId: string = this.reportService.getStoredReportId();
  inspectionReportGroups = computed(
    () =>
      this.reportGroupsService.storedInspectionReportGroups()[this.reportId],
  );
}
